export const PART_GUIDES = {
  Soprano: {
    about: "The highest voice part. Sopranos usually carry the melody in choirs and sit roughly from Middle C up to the A (or higher) above the treble stave.",
    clef: "Treble Clef — most of your notes sit on the treble stave, with some high notes on ledger lines above it.",
    warmups: [
      { name: "Lip trill slide", how: "Buzz your lips and slide up and down a 5-note scale.", start: "C4" },
      { name: "'Ma-me-mi-mo-mu'", how: "Sing each vowel on one note of a 5-note scale, up and back down.", start: "E4" },
      { name: "Gentle siren", how: "On 'ng' (as in 'sing'), glide from low to high and back like a siren.", start: "G4" },
    ],
    songs: ["Amazing Grace (traditional)", "I Dreamed a Dream (Les Misérables)", "Hallelujah (Leonard Cohen)"],
  },
  Alto: {
    about: "The lower female/unchanged voice part. Altos often sing harmony just below the melody, roughly from the F below Middle C up to the D in the treble stave.",
    clef: "Treble Clef — with some lower notes below the stave on ledger lines, around and just below Middle C.",
    warmups: [
      { name: "Lip trill slide", how: "Buzz your lips and slide up and down a 5-note scale.", start: "A3" },
      { name: "'Ma-me-mi-mo-mu'", how: "Sing each vowel on one note of a 5-note scale, up and back down.", start: "C4" },
      { name: "Humming 5ths", how: "Hum from the starting note up 5 notes and back, keeping it relaxed.", start: "D4" },
    ],
    songs: ["Someone Like You (Adele)", "At Last (Etta James)", "Lean on Me (Bill Withers)"],
  },
  Tenor: {
    about: "The higher male voice part. Tenors often sing melody or high harmony, roughly from the C below Middle C up to the A above it.",
    clef: "Bass Clef — with higher notes above the stave on ledger lines (tenor parts are also often written in the treble clef, sounding an octave lower).",
    warmups: [
      { name: "Lip trill slide", how: "Buzz your lips and slide up and down a 5-note scale.", start: "C3" },
      { name: "'Ma-me-mi-mo-mu'", how: "Sing each vowel on one note of a 5-note scale, up and back down.", start: "E3" },
      { name: "Gentle siren", how: "On 'ng' (as in 'sing'), glide from low to high and back like a siren.", start: "G3" },
    ],
    songs: ["Let It Be (The Beatles)", "Your Song (Elton John)", "Stand by Me (Ben E. King)"],
  },
  Bass: {
    about: "The lowest voice part. Basses give the choir its foundation, roughly from the low E in the bass stave up to the E just above Middle C.",
    clef: "Bass Clef — with some low notes below the stave on ledger lines.",
    warmups: [
      { name: "Lip trill slide", how: "Buzz your lips and slide up and down a 5-note scale.", start: "F2" },
      { name: "'Ma-me-mi-mo-mu'", how: "Sing each vowel on one note of a 5-note scale, up and back down.", start: "A2" },
      { name: "Humming 5ths", how: "Hum from the starting note up 5 notes and back, keeping it relaxed.", start: "C3" },
    ],
    songs: ["Ol' Man River (Show Boat)", "Swing Low, Sweet Chariot (spiritual)", "Stand by Me (Ben E. King, in a low key)"],
  },
};
